"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.mapBy = exports.isNotEmpty = exports.has = exports.callOnChildren = void 0;
var _lodash = require("lodash");
var _array = require("./array");

/**
 * Great for prop-checking during Component cloning/creation.
 */
const has = v => Object.keys((0, _lodash.get)(v, 'props', {})).length;
/**
 * Invoke a func if children exist.
 */

exports.has = has;
const callOnChildren = (v, fn) => {
  const c = (0, _lodash.get)(v, 'props.children');
  if (typeof fn !== 'function') return undefined;
  return Array.isArray(c) ? c.map(fn) : fn(c);
};
exports.callOnChildren = callOnChildren;
const isNotEmpty = v => v !== null && v !== undefined && v.length;
exports.isNotEmpty = isNotEmpty;
const mapBy = (c, propName) => (0, _array.is)(c).flatMap(item => [(0, _lodash.get)(item, `props.${propName}`), mapBy((0, _lodash.get)(item, 'props.children', []), propName).filter(isNotEmpty)].flat());
exports.mapBy = mapBy;